import type {SVGProps} from 'react';
import * as React from 'react';

export const DamageIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		fill="none"
		viewBox="0 0 24 24"
		{...props}
	>
		<path
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={1.8}
			d="M14 1H2.693A1.7 1.7 0 0 0 1 2.702V7.67c.01 6.744 4.136 12.788 10.39 15.215.395.153.83.153 1.22 0v-.005C18.864 20.453 22.995 14.409 23 7.67V2.702A1.7 1.7 0 0 0 21.307 1H14Zm0 0L9 8.5l6.5 2.75L11 17"
		/>
	</svg>
);
